export default "__VITE_ASSET__D3VQZtL9__"